"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _merchantElectricity = require("@/api/merchantElectricity");
var _utils = require("./utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MerchantElectricityOverview',
  data: function data() {
    return {
      loading: false,
      overview: {}
    };
  },
  computed: {
    cards: function cards() {
      var o = this.overview || {};
      return [{
        key: 'pending',
        title: '待确认账单',
        value: o.bill_pending != null ? o.bill_pending : 0,
        status: 0
      }, {
        key: 'confirmed',
        title: '待打款',
        value: o.bill_confirmed != null ? o.bill_confirmed : 0,
        status: 1
      }, {
        key: 'settled',
        title: '已结算',
        value: o.bill_settled != null ? o.bill_settled : 0,
        status: 2
      }, {
        key: 'failed',
        title: '结算失败',
        value: o.bill_failed != null ? o.bill_failed : 0,
        status: 3
      }, {
        key: 'withdraw',
        title: '累计电费打款(元)',
        value: (0, _utils.formatMoney)(o.withdraw_total_amount),
        status: null
      }, {
        key: 'balance',
        title: '我的可用余额(元)',
        value: (0, _utils.formatMoney)(o.payer_available_money),
        status: null
      }];
    }
  },
  mounted: function mounted() {
    this.loadData();
  },
  methods: {
    loadData: function loadData() {
      var _this = this;
      this.loading = true;
      (0, _merchantElectricity.getManageOverview)().then(function (res) {
        _this.overview = res || {};
      }).catch(function (err) {
        _this.$message.error(err && err.msg || '加载概览失败');
      }).finally(function () {
        _this.loading = false;
      });
    },
    goBillList: function goBillList(card) {
      if (card.status === null || card.status === undefined || card.status === '') {
        this.$router.push({
          path: '/merchant-electricity/monthly-bill'
        });
        return;
      }
      this.$router.push({
        path: '/merchant-electricity/monthly-bill',
        query: {
          status: String(card.status)
        }
      });
    }
  }
};